/*!
 * Date guards for every birth-date field on the site.
 *
 * A native date input accepts a six-digit year - the HTML spec allows years up
 * to 275760 - so a fast typist lands on 199605 without noticing. min/max stops
 * the picker offering nonsense and marks a typed value out of range; the input
 * handler then trims the year back to four digits as it is typed, because a
 * silently invalid field reads to the user as a broken button later on.
 *
 * The lower bound is the calendar library's own useful range.
 */
(function (root) {
  'use strict';
  var MIN_YEAR = 1900;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function today() {
    var d = new Date();
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }
  function maxYear() { return new Date().getFullYear(); }

  function guard(input) {
    if (!input || input.dataset.bcGuarded) return;
    input.dataset.bcGuarded = '1';
    input.min = MIN_YEAR + '-01-01';
    input.max = today();

    input.addEventListener('input', function () {
      var v = input.value;
      if (!v) return;
      var m = v.match(/^(\d+)-(\d{2})-(\d{2})$/);
      if (!m) return;
      var y = m[1];
      /* Trim as they type rather than waiting for blur: the browser keeps
         accepting digits, so 1996 becomes 19960 becomes 199605 in three
         keystrokes and the field looks fine while being unusable. */
      if (y.length > 4) {
        input.value = y.slice(0, 4) + '-' + m[2] + '-' + m[3];
      }
    });
  }

  /**
   * @param {HTMLInputElement} input
   * @returns {boolean} true when the value is a usable birth date
   */
  function isValid(input) {
    var v = input && input.value;
    if (!v) return false;
    var m = v.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return false;
    var y = parseInt(m[1], 10);
    if (y < MIN_YEAR || y > maxYear()) return false;
    return new Date(v + 'T12:00:00Z').getTime() <= Date.now();
  }

  function bindAll() {
    Array.prototype.forEach.call(
      document.querySelectorAll('input[type="date"]'), guard);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }


/* Hook-block labels follow the READING language, not the page language:
   an English page can serve a Chinese reading, and an English "Want to go
   deeper?" inside it reads as a seam. */
window.BC_RL = {
  en:{h:'Want to go deeper?',l:'See what the full reading covers →'},
  de:{h:'Möchten Sie tiefer gehen?',l:'Sehen Sie, was die vollständige Deutung abdeckt →'},
  fr:{h:'Envie d’aller plus loin ?',l:'Voir ce que couvre la lecture complète →'},
  es:{h:'¿Quieres profundizar?',l:'Ver qué cubre la lectura completa →'},
  pt:{h:'Quer ir mais fundo?',l:'Veja o que a leitura completa cobre →'},
  it:{h:'Vuoi approfondire?',l:'Scopri cosa copre la lettura completa →'},
  ru:{h:'Хотите глубже?',l:'Что входит в полный разбор →'},
  ja:{h:'さらに深く知りたい方へ',l:'完全版の内容を見る →'},
  ko:{h:'더 깊이 알고 싶다면?',l:'전체 해석에 포함된 내용 보기 →'},
  'zh-CN':{h:'想看得更深？',l:'看看完整详批还讲什么 →'},
  'zh-TW':{h:'想看得更深？',l:'看看完整詳批還講什麼 →'}
};

  root.BCDates = { guard: guard, isValid: isValid, minYear: MIN_YEAR };
})(window);
